// extracted by mini-css-extract-plugin
export default {"DashBoardPageContainer":"styles_DashBoardPageContainer__ToPBR","column":"styles_column__asE3B","cardsWrapper":"styles_cardsWrapper__bKrgc"};